import { AuthCallbackPage } from "@/features/auth/pages/AuthCallback";

const AuthCallback = () => {
  return <AuthCallbackPage />;
};

export default AuthCallback;
